import { Reveal } from '../Shared';
import { useLocale } from '../../i18n/LocaleProvider';
import './TeamProfileCard.css';

const labels = {
  en: { view: 'View profile', open: 'Open profile for' },
  fr: { view: 'Voir le profil', open: 'Ouvrir le profil de' },
  es: { view: 'Ver perfil', open: 'Abrir el perfil de' },
};

export const TeamProfileCard = ({ member, index, group = 'leadership', founder = false, onOpen }) => {
  const { locale } = useLocale();
  const copy = labels[locale] || labels.en;
  return <Reveal delay={founder ? index * .12 : (index % 4) * .045} className={`team-profile-card ${founder ? 'team-founder-card glass' : 'team-member-card'}`} data-testid={`${founder ? 'team-founder' : 'team-member'}-${member.id}`}>
    <button type="button" className="team-card-trigger" onClick={() => onOpen(member)} aria-label={`${copy.open} ${member.name}`} data-testid={`team-open-${member.id}`}>
      <span className="sr-only">{copy.view}</span>
    </button>
    <div className={founder ? 'team-founder-portrait' : 'team-portrait'}>
      {member.image ? (
        <img
          src={member.image}
          alt={member.name}
          loading="lazy"
          data-testid={`team-photo-${member.id}`}
          onError={e => { e.currentTarget.style.display = 'none'; }}
        />
      ) : null}
      <div className="profile-photo-shade" aria-hidden="true" />
      <span className="team-view-profile" aria-hidden="true" data-testid={`team-view-profile-${member.id}`}>{copy.view}</span>
    </div>
    {founder
      ? <div className="team-founder-info"><div><span className="team-role" data-testid={`team-role-${member.id}`}>{member.title}</span><h2 data-testid={`team-name-${member.id}`}>{member.name}</h2></div><span className="founder-caption" data-testid={`team-caption-${member.id}`}>TECHSPITZE LEADERSHIP <span aria-hidden="true">↗</span></span></div>
      : <div className="team-member-info"><h3 data-testid={`team-name-${member.id}`}>{member.name}</h3>{member.title && <p data-testid={`team-role-${member.id}`}>{member.title}</p>}</div>}
  </Reveal>;
};
